export default __webpack_public_path__ + "static/media/ballr_slider2.fbf24163.png";